import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { LieuStockageDto } from '@lexi-clients/lexi';
import { LieuStockageListResult } from '../models/lieu-stockage-list';

@Injectable({
  providedIn: 'root'
})
export class LieuStockageListService implements IGridService<LieuStockageDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<LieuStockageListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/LieuStockages/recherche-devexpress`, { params: params });
  }

  getById(lieuStockageId: number): Observable<LieuStockageDto> {
    return this.http.get<any>(`${this.baseUrl}/api/LieuStockages/${lieuStockageId}`);
  }

  post(valeur: LieuStockageDto): Observable<any> {
    return null;
  }

  put(valeur: LieuStockageDto): Observable<any> {
    return null;
  }

  delete(valeur: LieuStockageDto): Observable<any> {
    return null;
  }
}
